import { getDataWithPromise, Globals, handleAjaxError } from "./BaseDataFns";
import {translatePostFilter} from "root/DataFunctions/Constants";

export const getPostDetails = (post_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/post/' + post_id;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const saveNewPost = ( current_user, postFormData, messageType, onCompleteFunc) => {
    let recipient = null;

    if(current_user === null)
    {
        recipient = postFormData['post']['child_uid']['idusers'] !==null ? postFormData['post']['child_uid']['idusers'] : 'current';
    }
    else{
        recipient = current_user;
    }

    const url = Globals.APIFolder + '/user/' + recipient + '/posts?messageType=' + messageType;

    getDataWithPromise(url, 'POST', { formData: postFormData }).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
};

export const updatePost = ( child_uid, post_id, postFormData, messageType, onCompleteFunc) => {

    const url = Globals.APIFolder + '/post/' + post_id + '?messageType=' + messageType;

    getDataWithPromise(url, 'POST', {formData: postFormData}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
};

export const deletePost = ( chid_uid, post_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/post/' + post_id;

    getDataWithPromise(url, 'DELETE', {} ).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
};

//gets child's posts for a selected year
export const getChildsPostsForYear = (year, onCompleteFunc) => {

    const url = Globals.APIFolder + '/child/me/posts?year=' + year;

    getDataWithPromise(url, 'get', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

export const getMyContributionCount = ( user_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/statistics/myContributions' ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

//Gets your posts filter by status
export const getUserPosts = (filter, onCompleteFunc) =>
{
    const post_status = translatePostFilter(filter);
    const url = Globals.APIFolder + '/user/current/posts?post_status=' + post_status;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

//Gets your post to approve
export const getPostsForApproval = (onCompleteFunc) => {
    const url = Globals.APIFolder + '/user/current/postsForApproval';

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

//Gets your posts for a specific user, filter by status
//The see
export const getSentPostsForUser = (user_id, statusFilter, senderFiler, onCompleteFunc) => {
    const post_status = translatePostFilter(statusFilter);
    const url = Globals.APIFolder + '/user/' + senderFiler + '/user/' + user_id + '/posts?post_status=' + post_status;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

